import type { DefaultConfiguration } from "../types";

import { Home3, MessageQuestion, Messages1 } from "iconsax-react";

export const defaultConfiguration: DefaultConfiguration = {
  position: "bottom-right",
  sections: [
    {
      icon: <Home3 color="#948A8A" size="20" />,
      id: "Home",
      title: "Home",
    },
    {
      icon: <MessageQuestion color="#948A8A" size="20" />,
      id: "Issue",
      title: "Report an Issue",
    },
    {
      icon: <Messages1 color="#948A8A" size="20" />,
      id: "Chat",
      title: "Live Chat",
    },
  ],

  supportGuide: {
    gradient: ["#ff9e9988", "white"],
    system: "Exchange",
    titles: [
      {
        description: "getting started AFEX System",
        guideSections: [
          {
            heading: "Step 1: Download the App",
            steps: [
              "Head to your app store (Google Play Store or Apple App Store) and search for [App Name].",
              "Tap the Install button and wait for the app to download.",
            ],
          },
          {
            heading: "Step 2: Download the App",
            steps: [
              "Open the app and tap on Sign Up.",
              "Provide your details such as name, email, and a secure password.",
            ],
          },
        ],
        heading: "Getting Started with AFEX System",
        id: 1,
      },
    ],
  },
};
